import { gql } from "graphql-request";

const EXPERIMENT_FIELDS = gql`
  fragment ExperimentFields on ExperimentSchemaModel {
    _id
    key
    name
    description
    status
    variants {
      key
      weight
    }
    targeting {
      newUsersOnly
      platforms
      startDate
      endDate
    }
    createdAt
    updatedAt
  }
`;

export const ADMIN_EXPERIMENTS = gql`
  ${EXPERIMENT_FIELDS}
  query AdminExperiments($status: ExperimentStatus) {
    adminExperiments(status: $status) {
      ...ExperimentFields
    }
  }
`;

export const ADMIN_EXPERIMENT = gql`
  ${EXPERIMENT_FIELDS}
  query AdminExperiment($key: String!) {
    adminExperiment(key: $key) {
      ...ExperimentFields
    }
  }
`;
